import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"
import SimpleBar from "simplebar-react"
import withRouter from "components/Common/withRouter"
import MetisMenu from "metismenujs"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">

          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-view-dashboard"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-email-outline"></i>
                <span>{props.t("Forms And Collaterals")}</span>
              </Link>
              <ul className="sub-menu" >
                <li>
                  <Link to="/form">{props.t("Forms")}</Link>
                </li>
                <li>
                  <Link to="/collaterals">{props.t("Collaterals")} </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-tshirt-crew"></i>
                <span>{props.t("Products")}</span>
              </Link>

              <ul className="sub-menu">
                <li>
                  <Link to="/products">
                    {props.t("Products Listing")}
                  </Link>
                </li>

                <li>
                  <Link to="/add-product" className="dropdown-item">
                    {props.t("Add Product")}
                  </Link>
                </li>

              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-washing-machine"></i>
                <span>{props.t("Visicoolers")}</span>
              </Link>
              <ul className="sub-menu" >
                <li>
                  <Link to="/visicoolers">{props.t("Visicooler Listing")}</Link>
                </li>
                <li>
                  <Link to="/add-visicooler">{props.t("Add Visicooler")} </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-cart"></i>
                <span>{props.t("Orders")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/orders">{props.t("Orders Listing")}</Link>
                </li>
                <li>
                  <Link to="/add-order">{props.t("Create Order")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-album"></i>
                <span>{props.t("Designations")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/designations">
                    {props.t("Designations Listing")}
                  </Link>
                </li>
                <li>
                  <Link to="/add-designation">{props.t("Add Designation")}</Link>
                </li>

              </ul>
            </li>

            <li>
              <Link to="/" className="has-arrow waves-effect">
                <i className="mdi mdi-home-map-marker"></i>
                <span>{props.t("Addresses")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/address-listing">{props.t("Address Listing")}</Link>
                </li>
                <li>
                  <Link to="/add-address">{props.t("Add Address")}</Link>
                </li>

              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-earth"></i>
                <span>{props.t("Region")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/region-listing">{props.t("Region Listing")}</Link>
                </li>
                <li>
                  <Link to="/add-region">{props.t("Add Region")}</Link>
                </li>

              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-human-male-male"></i>
                <span>{props.t("Regional Managers")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/regional-managers">{props.t("Regional Managers Listing")}</Link>
                </li>
                <li>
                  <Link to="/add-regional-manager">{props.t("Add Regional Manager")}</Link>
                </li>
              </ul>
            </li>


            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-human-child"></i>
                <span>{props.t("Employees")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/employee-listing">{props.t("Employees Listing")}</Link>
                </li>
                <li>
                  <Link to="/add-employee" >
                    {props.t("Add Employee")}
                  </Link>

                </li>
              </ul>
            </li>


            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-text-box-multiple-outline"></i>
                <span>{props.t("Reports")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/all-region-reports">{props.t("Region Reports")}</Link>
                </li>
                <li>
                  <Link to="/product-reports">{props.t("Product Reports")}</Link>
                </li>

                <li>
                  <Link to="/budget-reports">{props.t("Budget Reports")}</Link>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))